<style scoped lang="scss" type="text/scss">

</style>

<template>
    <el-cascader
            class="full-width"
            :options="regions"
            clearable
            v-model="valueSync"
            @active-item-change="handleItemChange"
            :props="props"
    >
    </el-cascader>
</template>

<script>
    import _ from 'lodash';

    export default {
        name: '',
        props: {
            value: Number,
            placeholder: String
        },
        data () {
            return {
                valueSync: [],
                props: {
                    value: 'id',
                    children: 'children',
                    label: 'name'
                }
            };
        },
        created () {
            if (this.regions.length === 0) {
                this.$store.dispatch('constant/loadProvinces').then();
            }
        },
        computed: {
            regions () {
                return this.$store.state.constant.regions;
            }
        },
        watch: {
            value: {
                immediate: true,
                handler (value) {
                    if (value === undefined || value === null || value <= 0) {
                        this.valueSync = [];
                    } else {
                        //刷新时候，展示出来
                        const param = {id: value};
                        this.$store.dispatch('constant/loadRegionCoverTree', param).then();
                        this.$store.dispatch('constant/loadRegionInfo', param).then(response => {
                            this.valueSync = _.map(_.get(response, 'data.gene', '').split('/'), item => +item);
                        });
                    }
                }
            },
            valueSync (value) {
                this.$emit('input', value[value.length - 1]);
            }
        },
        methods: {
            handleItemChange (value) {
                //切换下拉框的父级的时候重新获取子项的值
                const regionId = value[value.length - 1];
                this.$store.dispatch('constant/loadSubRegions', {
                    id: regionId
                }).then();
            }
        }
    };
</script>
